import React from 'react'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__sleepMode.jcss'
import { SwitchButton } from '../../../atoms/SwitchButton'
import { Typography } from '../../../atoms/Typography'

type SleepModeSettings = {
    downloadEnabled?: boolean
    allowManualWake?: boolean
}

const SleepMode = (p_: {
    enabled: boolean
    data: SleepModeSettings
    onChange: (value: SleepModeSettings, field: string) => void
}) => {
    const downloadEnabled = p_.data?.downloadEnabled ?? false
    const allowManualWake = p_.data?.allowManualWake ?? true

    const onChangeData = (patch: Partial<SleepModeSettings>) => {
        p_.onChange(
            {
                ...(p_.data || {}),
                ...patch,
            },
            'sleepModeSettings'
        )
    }

    return p_.enabled ? (
        <div className={styles.content}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={downloadEnabled}
                    onChange={() => {
                        onChangeData({ downloadEnabled: !downloadEnabled })
                    }}
                    className={`test-settings-toggle_${downloadEnabled ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('allowDownloadsInSleepMode')}
                    </Typography>
                </div>
            </div>
            <div className={cn(styles.switchWrapper, styles.switchWrapperSpaced)}>
                <SwitchButton
                    checked={allowManualWake}
                    onChange={() => {
                        onChangeData({ allowManualWake: !allowManualWake })
                    }}
                    className={`test-settings-toggle_${allowManualWake ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('allowManualExitFromSleepMode')}
                    </Typography>
                </div>
            </div>
        </div>
    ) : null
}

export default React.memo(SleepMode)
